import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import StripeLinkPaymentForm from "@/modules/billing/stripe/StripeLinkPaymentForm.tsx";
import { getStripe } from "@/modules/billing/stripe/utils.ts";
import type { StripeWalletConfig } from "@warrenio/api-spec/spec.oats.gen";

export function makeStripeLink(config: StripeWalletConfig) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => (
                // Stripe SDK is instantiated here in the payment method initializer - this preloads it and also avoids "only once" logic in the React component
                <StripeLinkPaymentForm {...props} stripe={getStripe(config)} method={method} config={config} />
            ),
        };
    });
}
